export default __webpack_public_path__ + "static/media/home-page-keep-eveyone-in-check.e733691f.png";